"use strict";
exports.__esModule = true;
function getElement(_a, config) {
    var $ = _a.$, el = _a.el;
    if (!config)
        return $(el);
    var selector = config.selector, type = config.type;
    var element;
    if (!selector) {
        element = $(el || 'html');
    }
    else if (el) {
        element = $(el).find(selector);
    }
    else {
        element = $(selector);
    }
    return type !== 'array' ? element.first() : element;
}
exports["default"] = getElement;
